import React from 'react';
import useSpotlight3Store from '../../store/useSpotlight3Store';
import './Spotlight3Featured.scss';

function Spotlight3Featured() {
  const [featuredImage, featuredImageDescription] = useSpotlight3Store((state) => [state.featuredImage, state.featuredImageDescription]);

  return (
    <div className="sptlght3__featured">
      <img src={featuredImage} alt="Tyler's open edition, blue" />
      <div className="sptlght3__featured-description"><p>{featuredImageDescription}</p></div>
    </div>
  );
}

export default Spotlight3Featured;
